(function () {
  // Two ways to arm a click target:
  //  1) the theme's own rating block in product-info (legacy, matched by convention),
  //  2) ANY element carrying data-scroll-to-reviews (explicit opt-in for custom layouts).
  const CLICK_SELECTOR = '[data-scroll-to-reviews], .product-info__block-item[data-block-type="rating"] .rating-badge';
  const TARGET_SELECTOR = '[data-oke-widget], .okeReviews';

  // Ile px NAD sekcją ma się zatrzymać (dopasuj)
  const OFFSET_PX = 160;

  function scrollToReviewsWithOffset() {
    const target = document.querySelector(TARGET_SELECTOR);
    if (!target) return;

    const y = target.getBoundingClientRect().top + window.pageYOffset - OFFSET_PX;

    window.scrollTo({
      top: Math.max(y, 0),
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function (e) {
    const clicked = e.target.closest(CLICK_SELECTOR);
    if (!clicked) return;

    e.preventDefault();
    scrollToReviewsWithOffset();
  });
})();
